import React from 'react';

export interface CircleLoaderProps {
    loading: boolean
    loaderClass?: string
}

const CircleLoader: React.FunctionComponent<CircleLoaderProps> = (props) => {
    let showLoaderClass = props.loading ? "active" : '';
    const loaderClass = props.loaderClass ? props.loaderClass : '';
    const className = "loader-container loader-circle " + loaderClass;
    return (
        <div className={"loader " + showLoaderClass} >
            <div className={className}>
                <div className="lds-circle"></div>
            </div>
            </div>


    )
}

export default CircleLoader;